module.exports = __webpack_public_path__ + "img/img_title_fuwudian_normal.d78c5818.png";